<script lang="ts">
import CarrotBanner from "@shared/svelte/Components/Banner/CarrotBanner.svelte";
import KevelBanner from "@shared/svelte/Components/Banner/KevelBanner.svelte";
import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
import type { Banner } from "@shared/types/Banner";

export let banners: Banner[];
export let mobileMode: boolean;
export let pageName: string | null = null;
</script> 

{#if stagedRolloutCheck("kevel_ads")}
    {#if banners && banners.length > 0}
        <KevelBanner {banners} {mobileMode} {pageName} />
    {/if}
{:else}
    <CarrotBanner {banners} {mobileMode} {pageName} />
{/if}   